import { Group, Skeleton, Text as MantineText } from '@mantine/core';
import { useLingui } from '@lingui/react';
import { IconUser } from '@tabler/icons';
import { FC, useContext, useEffect } from 'react';
import { useAppUser } from '../../Service/Context/ApplicationUserContext';
import { ProfileContext } from '../../Service/Context/ProfileContext';
import { ProfileShare } from '../../Service/ProfileS';

const getShareDescription = ({ firstName, lastName, email }: ProfileShare) => {
  const displayName = [firstName, lastName].filter(Boolean).join(' ').trim();
  return displayName || email;
};

const EventApplicationUserAssignment: FC<{ applicationUserId?: number | null; maxWidth?: number }> = ({
  applicationUserId,
  maxWidth,
}) => {
  const { i18n } = useLingui();
  const applicationUser = useAppUser();
  const { bookitupTeam } = useContext(ProfileContext);
  const loading = bookitupTeam?.loading ?? false;
  const shares = bookitupTeam?.shares ?? [];
  const sharesLoaded = bookitupTeam?.sharesLoaded ?? false;

  useEffect(() => {
    if (applicationUserId) {
      bookitupTeam?.ensureSharesLoaded().catch(() => undefined);
    }
  }, [applicationUserId, bookitupTeam]);

  if (!applicationUserId) {
    return null;
  }

  const share = shares.find((profileShare) => profileShare.applicationUserId === applicationUserId);
  const shareDescription = share ? getShareDescription(share) : undefined;
  const currentApplicationUserId = applicationUser.applicationUserId ?? applicationUser.id;
  let assignedUserDescription: string | undefined;
  if (currentApplicationUserId === applicationUserId) {
    assignedUserDescription = i18n._('event.assignment.assignedToMe');
  } else if (shareDescription) {
    assignedUserDescription = i18n._('event.assignment.assignedToUser', { user: shareDescription });
  }

  if (!shareDescription && currentApplicationUserId !== applicationUserId && loading && !sharesLoaded) {
    return <Skeleton height={16} width={160} />;
  }

  if (!shareDescription && currentApplicationUserId !== applicationUserId) {
    return null;
  }

  return (
    <Group spacing={4} noWrap>
      <IconUser size={14} color="gray" />
      <MantineText size="xs" color="dimmed" className="overflow-ellipsis" sx={{ maxWidth }}>
        {assignedUserDescription}
      </MantineText>
    </Group>
  );
};

export default EventApplicationUserAssignment;
